import {KycRepositoryV2} from "./kyc.repository.v2";

export type {KycRepository} from "./kyc.repository";
export {KycRepositoryV2};

/**
 * Factory function to create the KYC repository.
 * v2 only — no v1 repository exists for KYC in the new architecture.
 */
export const createKycRepository = (): KycRepositoryV2 => {
  return new KycRepositoryV2();
};
